import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cost_design_icon from "../assets/svg/cost_design_icon.svg";
import computer_icon from "../assets/svg/computer-icon.png";
import leftmove from "../assets/svg/leftmove_arrow.svg";
import '../styles/LoginPage.css';
import { ToastContainer, toast } from "react-toastify";
import { FiMail } from "react-icons/fi";
import axiosInstance from "../axiosInstance";
import lentera from "../assets/svg/lentera-icon.svg";

const ForgetPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleGetCode = async () => {
        if (!email.trim()) {
            toast.error("Please enter your email");
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post("/forgotpassword", { email });

            if (response.data.success) {
                toast.success(response.data.message || "Reset password link sent successfully");
               navigate("/verifyCode", { state: { email } });
            } else {
                toast.error(response.data.message || "Something went wrong");
            }
        } catch (error) {
            console.error(error);

            if (error.response && error.response.data) {
                const data = error.response.data;
                if (data.message) {
                    toast.error(data.message); 
                } else if (data.error) {
                    const errors = data.error;
                    const firstError = Object.values(errors)[0][0];
                    toast.error(firstError);
                } else {
                    toast.error("Failed to send reset password link");
                }
            } else {
                toast.error("Failed to send reset password link");
            }
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <div className="login-page">
                <div className="left-panel">
                    <div className="logo">
                        <img src={cost_design_icon} alt='' className='cost-design-icon' />
                        <span>WBS</span>
                    </div>
                    <h2>PRECISION WAREHOUSE BILLING MADE <br />SIMPLE</h2>
                    <div className="laptop-container">
                        <img src={computer_icon} alt="Laptop Hand" className="laptop-image" />
                        <div className="laptop-shadow"></div>
                    </div>
                </div>

                <div className="right-panel">
                    <img
                        src={leftmove}
                        onClick={() => navigate(-1)}
                        style={{ width: '30px', height: '30px', marginBottom: '10px', cursor: 'pointer' }}
                        alt=""
                    />
                    <h2>Forgot Password?</h2>
                    <p>We’ll send a 6-digit verification code to your email</p>

                    <div className="login-form" style={{ marginTop: '15px' }}>
                        <label>Email Address <span style={{ color: 'red' }}>*</span></label>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #E0E0E0",
                                borderRadius: "12px",
                                padding: "0 10px",
                                height: "40px",
                                backgroundColor: "#fff",
                                marginTop: '8px'
                            }}
                        >
                            <FiMail style={{ marginRight: "10px", color: "#cbd5e1" }} />
                            <input
                                type="email"
                                placeholder="abc@gmail.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{
                                    flex: 1,
                                    border: "none",
                                    outline: "none",
                                    height: "100%",
                                    background: "transparent",
                                    fontSize: "14px",
                                }}
                            />
                        </div>

                        <button
                            type="button"
                            className="sign-in-button"
                            onClick={handleGetCode}
                            disabled={loading}
                        >
                            {loading ? "Sending..." : "Get Code"}
                        </button>
                    </div>

                    <p style={{ marginTop: "20px", cursor: "pointer" }}>
                        By submitting, you agree to our <span style={{ color: '#097BED' }}>Terms & Conditions</span>
                    </p>

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            fontSize: "12px",
                            color: "#666",
                            marginTop: "16px",
                        }}
                    >
                        <span>{new Date().getFullYear()} © Powered by</span>
                        <a href="https://lenteratech.com/" target="_blank" rel="noreferrer">
                            <img
                                src={lentera}
                                alt="Lentera"
                                style={{
                                    height: "14px",
                                    display: "block",
                                }}
                            />
                        </a>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default ForgetPassword;
